// eslint-disable-next-line import/prefer-default-export
export const parseIdParam = (param: string): string | null => {
  if (param === 'null') {
    return null;
  }
  return param;
};
